import {
  BanknotesIcon,
  Bars3BottomLeftIcon,
  BuildingStorefrontIcon,
  ChatBubbleBottomCenterTextIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
  Cog8ToothIcon,
  MapIcon,
  NewspaperIcon,
  PowerIcon,
  ReceiptPercentIcon,
  UsersIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import {
  Badge,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemPrefix,
  Typography,
} from "@material-tailwind/react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../lib/user";
import useChatrooms from "../store/chatrooms";
import useUser from "../store/user";

const baseLinks = [
  // { href: '/', label: 'Home', icon: HomeIcon },
  {
    href: "/active-orders",
    label: "Active Orders",
    icon: ClipboardDocumentListIcon,
  },
  {
    href: "/order-history",
    label: "Order History",
    icon: ClockIcon,
  },
  {
    href: "/chatrooms",
    label: "Support Chats",
    icon: ChatBubbleBottomCenterTextIcon,
  },
  {
    href: "/refunds",
    label: "Refund Status",
    icon: BanknotesIcon,
  },
  {
    href: "/invoices",
    label: "Invoices",
    icon: ReceiptPercentIcon,
  },
  {
    href: "/daily-reports",
    label: "Daily Reports",
    icon: NewspaperIcon,
  },
  {
    href: "/customer-data",
    label: "Customer Data",
    icon: UsersIcon,
  },
  {
    href: "/consumer-heatmap",
    label: "Consumer Heatmap",
    icon: MapIcon,
  },
  {
    href: "/restaurants",
    label: "Restaurants",
    icon: BuildingStorefrontIcon,
  },
  {
    href: "/settings",
    label: "Settings",
    icon: Cog8ToothIcon,
  },
  // { href: '/order-history', label: 'Order History', icon: QuestionMarkCircleIcon },
  // { href: '/chat', label: 'Support Chat', icon: InboxIcon },
  // { href: '/settings', label: 'Settings', icon: Cog6ToothIcon },
];

export default function Sidebar() {
  const location = useLocation();
  const { user } = useUser();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const {chatrooms} = useChatrooms();

  const numberOfUnreadChatrooms = Object.values(chatrooms).filter(c => c.hasBeenReadByParticipant === false).length;

  const canChatSupport = user?.permissionKeys?.includes(
    'SUPER_ADMIN_CAN_CHAT_SUPPORT'
  );
  const canViewOrders = user?.permissionKeys?.includes(
    'SUPER_ADMIN_CAN_VIEW_ORDER'
  );
  const canViewRefunds = user?.permissionKeys?.includes(
    'SUPER_ADMIN_CAN_REQUEST_REFUNDS'
  );
  const canViewInvoices = user?.permissionKeys?.includes(
    'SUPER_ADMIN_CAN_VIEW_INVOICES'
  );

  const canViewDailyReports = user?.permissionKeys?.includes(
    'SUPER_ADMIN_CAN_VIEW_DAILY_REPORTS'
  )  && !!user.producerKey;

  const canViewCustomerData = user?.permissionKeys?.includes(
    'SUPER_ADMIN_CAN_VIEW_CUSTOMER_DATA'
  ) && !!user.producerKey;

  const canConfigureRestaurants = user?.permissionKeys?.includes(
    'SUPER_ADMIN_CAN_CONFIGURE_RESTAURANTS'
  );

  const linkFilters: String[] = [];

  if (!canChatSupport) {
    linkFilters.push('/chatrooms');
  }
  if (!canViewOrders) {
    linkFilters.push('/active-orders');
  }
  if (!canViewRefunds) {
    linkFilters.push('/refunds');
  }
  if (!canViewInvoices) {
    linkFilters.push('/invoices');
  }
  if (!canViewDailyReports) {
    linkFilters.push('/daily-reports');
  }
  if (!canViewCustomerData) {
    linkFilters.push('/customer-data');
    linkFilters.push('/consumer-heatmap');
  }
  if (!canConfigureRestaurants) {
    linkFilters.push('/restaurants');
  }


  const links = user?.isAnonymous ? [] : baseLinks.filter(link => !linkFilters.includes(link.href));

  return (
    <Card className="shadow-xl shadow-blue-gray-900/5">
      <div className="p-4 flex justify-between align-center">
        <Typography variant="h4" color="blue-gray">
          Relay Delivery
        </Typography>
        <IconButton
          variant="text"
          className="md:hidden"
          onClick={() => setIsOpen(prev => !prev)}
        >
          {isOpen ? (
            <XMarkIcon className="h-6 w-6" />
          ) : (
            <Bars3BottomLeftIcon className="h-6 w-6" />
          )}
        </IconButton>
      </div>

      <List
        className={`absolute w-full bg-white z-[21] top-full md:static ${
          !isOpen && 'hidden'
        } md:flex`}
      >
        {links.map((link, idx) => (
          <Link key={link.label} to={link.href}>
            <ListItem selected={location.pathname === link.href}>
              <ListItemPrefix>
                <link.icon className="h-5 w-5" />
              </ListItemPrefix>
              <Badge content={numberOfUnreadChatrooms} invisible={link.href !== '/chatrooms' || numberOfUnreadChatrooms === 0}>
              <div>{link.label}</div>
              </Badge>
            </ListItem>
          </Link>
        ))}
        <ListItem
          onClick={async () => {
            await logout();
            navigate('/');
          }}
        >
          <ListItemPrefix>
            <PowerIcon className="h-5 w-5" />
          </ListItemPrefix>
          Logout
        </ListItem>
      </List>
    </Card>
  );
}
